import $ from "jquery";

function frontPageSliderConfig() {
  return {
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    appendDots: $('.dots-holder'),
    customPaging: function(slider, i) {
      var title = $(slider.$slides[i]).find('.slider__item').data('title');
      var textColor = $(slider.$slides[i]).find('.slider__item').data('text-color');
      return `<a class="pager__item d-none d-lg-block pager__test" style="color: ${textColor}"><span class="pager__title">${title}</span></a>`;
    },
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          dots: true,
        }
      }
    ]
  }
}

function peopleAndExpertiseSliderConfig() {
  return {
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    prevArrow: '<button class="slick-arrow slick-prev" aria-label="previous"><svg class="icon icon-chevron-left"><use href="#icon-chevron-left"></svg></button>',
    nextArrow: ' <button class="slick-arrow slick-next" aria-label="next"><svg class="icon icon-chevron-right"><use href="#icon-chevron-right"></svg></button>',
    mobileFirst: true,
    infinite: false,
    responsive: [
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
          breakpoint: 1024,
          settings: {
              arrows: true,   
              slidesToShow: 4,
              slidesToScroll: 4,
              swipe: false
          }
      }
    ]
  }
}

function testimonialsSliderConfig() {
  return {
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    prevArrow: '<button class="slick-arrow slick-prev" aria-label="previous"><svg class="icon icon-chevron-left"><use href="#icon-chevron-left"></svg></button>',
    nextArrow: ' <button class="slick-arrow slick-next" aria-label="next"><svg class="icon icon-chevron-right"><use href="#icon-chevron-right"></svg></button>',
    mobileFirst: true,
    infinite: false,
    responsive: [
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
          breakpoint: 1400,
          settings: {
              dots: false,
              arrows: true,   
              slidesToShow: 3,
              slidesToScroll: 3,
              swipe: false
          }
      },
      {
        breakpoint: 1600,
        settings: {
            dots: false,
            arrows: true,   
            slidesToShow: 4,
            slidesToScroll: 4,
            swipe: false
        }
      }
    ]
  }
}

function transactionsSliderConfig() {
  return {
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    prevArrow: '<button class="slick-arrow slick-prev" aria-label="previous"><svg class="icon icon-chevron-left"><use href="#icon-chevron-left"></svg></button>',
    nextArrow: ' <button class="slick-arrow slick-next" aria-label="next"><svg class="icon icon-chevron-right"><use href="#icon-chevron-right"></svg></button>',
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          dots: false,
          arrows: true,
          swipe: false
        }
      }
    ]
  }
}

function insightsPageSliderConfig() {
  return {
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    variableWidth: true,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 1023,
        settings: 'unslick',
      }
    ]
  }
}

export {frontPageSliderConfig, peopleAndExpertiseSliderConfig, testimonialsSliderConfig, transactionsSliderConfig, insightsPageSliderConfig};
